import React from 'react'
import RightHandSide from '../../Common/Services/RightHandSide'
import AboutInnBanContent from '../../Common/InnerBanner/AboutInnBanContent';
import { AboutInnerBanner } from '../../Common/InnerBanner/AboutInnerBanner';
import HeadContent from '../BlogContent/HeadContent';
import HeadDesign from '../BlogContent/HeadDesign';
import Info from '../BlogContent/Info';
import List from '../BlogContent/List';
import InfoContent from '../BlogContent/InfoContent';
import ListContent from '../BlogContent/ListContent';
import RecentBlogsList from '../BlogContent/RecentBlogsList';
import { Helmet } from 'react-helmet';


const Blog17 = () => {
    const {image, heading, pageName} = AboutInnBanContent.BlogDetails;
    const {bg, para, date, blogHeading} = HeadContent.blog_17;

    const {title, p} = InfoContent.Blog_17.one;
    const {title2, p2} = InfoContent.Blog_17.two;
    const {title3, p3} = InfoContent.Blog_17.three;
    const {title4, p4} = InfoContent.Blog_17.four;
    //const {title5, p5} = InfoContent.Blog_17.five;
    const {title6, p6} = InfoContent.Blog_17.six;
    const {title7, p7} = InfoContent.Blog_17.seven;
    const {Ctitle, Cp} = InfoContent.Blog_17.conclusion;

    const {liss1} = ListContent.Blog_17.L1;
    const {liss2} = ListContent.Blog_17.L2;
    const {liss3} = ListContent.Blog_17.L3;
    const {liss4} = ListContent.Blog_17.L4;
  return (
    <>

        <Helmet>
            <title>
                IVF Specialist in Chembur | Best Fertility Clinic in Mumbai – Acme Fertility
            </title>

            <meta
                name="description"
                content="Searching for the best IVF specialist in Chembur? Acme Fertility offers advanced infertility treatments, IUI, IVF & expert care in Mumbai. Book consultation today!"
            />

            <meta
                name="keywords"
                content="best fertility clinic in Mumbai, infertility treatment Mumbai, IVF specialist Mumbai, fertility hospital Mumbai"
            />

            <link
                rel="canonical"
                href="https://www.acmefertility.com/17/BlogDetails"
            />
        </Helmet>

        

    <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

    <div className="blog-area pt-100 pb-70">
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <HeadDesign bg={bg} para={para} date={date} blogHeading={blogHeading} />
                    <Info title={title} p={p} />
                    <Info title={title2} p={p2} />
                    {/* <List liss={liss1} /> */}
                    <Info title={title3} p={p3} />
                    <Info title={title4} p={p4} />
                    
                    
                  

                    {/* <Info title={title5} p={p5} /> */}
                    <Info title={title6} p={p6} />
                   
                    
                    
                </div>
                <div className="col-lg-4">
                    <RecentBlogsList/>
                    <RightHandSide/>
                </div>
            </div>
        </div>
    </div>

    </>
  )
}

export default Blog17